import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Avatar from "../../../../../../../../assets/images/avatarr.png";
import "./index.css";
import capitalize from "../../../../../../../../capitalize";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { MdOutlineCancel } from "react-icons/md";
import { Select } from "antd";
import Spinner from "react-bootstrap/Spinner";
import { toast } from "react-toastify";
import { switchEndpoint } from "../../../../../../../../redux/actions/endpoints";
import axios from "axios";
import { storage } from "../../../../../../../../scopedStorage";

const PaymentRequestModal = ({
  showPaymentR,
  handleClosePaymentR,
  handleShowAuthenticate,
  bankList,
  setBankAcct,
  setBankCode,
  bankResult,
  isBankLoading,
  bankResultStatus,
  bankCode,
  bankAcct,
  getDropOff,
  setBankResult,
  setBankResultStatus,
}) => {
  const handleDataChange = (data) => {
    setBankCode(data);
  };
  const reference = JSON.parse(localStorage.getItem("reference"));

  const getDropOffInfo = async (code) => {
    try {
      const token = storage.getItem("token");
      const response = await axios.get(
        `${switchEndpoint}/collection-center/single-dropoff/${code}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const { data } = response.data;
      localStorage.setItem("reference", JSON.stringify(data));
      localStorage.setItem("dropOff", JSON.stringify(data.dropoff_details));
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    if (showPaymentR && reference?.code && !reference?.payment_details) {
      getDropOffInfo(reference.code);
    }
  }, [showPaymentR]);

  useEffect(() => {
    const checkReference = setInterval(() => {
      const updatedReference = JSON.parse(localStorage.getItem("reference"));
      if (JSON.stringify(updatedReference) !== JSON.stringify(reference)) {
        // window.location.reload();
      }
    }, 2000); // Check every 5 seconds

    return () => clearInterval(checkReference);
  }, [reference]);

  useEffect(() => {
    setBankAcct(null);
    setBankCode(null);
    setBankResult(null);
    setBankResultStatus(null);
  }, []);


  // console.log("this is the status ==>", bankResultStatus);
  return (
    <div>
      <Modal
        show={showPaymentR}
        onHide={() => {
          handleClosePaymentR();
          window.location.reload();
        }}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="text-left ml-3">
            <div className="mb-2">
              <h5 className="sec-headers mb-3">Payment Request Confirmed</h5>
              <div className="d-flex justify-content-between align-items-center">
                <p className="ftsz-regular" style={{ fontSize: "14px" }}>
                  {capitalize(reference?.owner?.roles[0])}:{" "}
                  {reference?.owner?.name}
                </p>
                <div className="d-flex align-items-center ">
                  <div>
                    <p
                      className="mb-0"
                      style={{ fontSize: "14px", color: "#898989" }}
                    >
                      Drop off Code
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#404040",
                        fontWeight: "700",
                      }}
                    >
                      {reference?.code}
                    </p>
                  </div>
                  <div className="imgAvatarHolder ml-3">
                    <img src={Avatar} alt="image" />
                  </div>
                </div>
              </div>

              <div className="text-center mt-3 mb-5">
                <div>
                  <p>You are to pay</p>
                  {reference?.payment_details ? (
                    <h1 className="fontBold">{`₦${reference?.payment_details?.amount}`}</h1>
                  ) : (
                    <Spinner
                      animation="border"
                      size="md"
                      className="my-2"
                      style={{ color: "#000" }}
                    />
                  )}
                  {/* <h1 className="fontBold">{`₦${reference?.dropoff_details?.total_price}`}</h1> */}
                  <p>To {reference?.owner?.name}</p>
                  <p>
                    Payment Method:{" "}
                    {reference?.payment_method === "cash"
                      ? "Cash"
                      : "Switch Transfer"}
                  </p>
                </div>

                {reference?.payment_method === "cash" ? (
                  <div>
                    <div className="px-4">
                      <Row>
                        <Col xs={6} md={6} className="text-left">
                          <Form.Label htmlFor="selectBank">
                            Select Bank
                          </Form.Label>
                          <Select
                            showSearch
                            className="large-select"
                            style={{
                              width: "100%",
                              fontSize: "16px", // Increase font size
                            }}
                            dropdownStyle={{
                              fontSize: "14px", // Ensure dropdown items match the input size
                            }}
                            placeholder="Select a Bank"
                            optionFilterProp="children"
                            onChange={handleDataChange}
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            <Select.Option value="">Select Bank</Select.Option>
                            {bankList.map((center) => (
                              <Select.Option
                                key={center.code}
                                value={center.code}
                              >
                                {center.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Col>
                        <Col xs={6} md={6} className="text-left">
                          <Form.Label htmlFor="accountNumber">
                            Account Number
                          </Form.Label>
                          <div className="position-relative">
                            <Form.Control
                              type="text"
                              id="accountNumber"
                              className="py-4"
                              maxLength={10}
                              onChange={(e) => {
                                const value = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                                setBankAcct(value);
                              }}
                            />
                            {bankResultStatus === 200 && (
                              <IoIosCheckmarkCircleOutline
                                size={24}
                                color="#c4da00"
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  // color: '#6c757d'
                                }}
                              />
                            )}

                            {bankResultStatus === 400 && (
                              <MdOutlineCancel
                                size={24}
                                color="#FF383C"
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  // color: '#6c757d'
                                }}
                              />
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="d-flex justify-content-between px-4">
                      <div />
                      <div>
                        {isBankLoading ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            className="mt-2"
                            style={{ color: "#c4da00" }}
                          />
                        ) : (
                          <div className="mt-1">
                            {bankResultStatus === 200 && <p>{bankResult}</p>}
                            {bankResultStatus === 400 && (
                              <p
                                style={{ color: "#FF383C", fontWeight: "500" }}
                              >
                                Account Not Found
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="mt-1 mb-5 w-btn m-auto pt-3">
                      <button
                        type="button"
                        className="btn loginBtn btn-sm btn-block d-flex justify-content-center align-items-center"
                        onClick={() => {
                          if (
                            !bankCode ||
                            !bankAcct ||
                            bankAcct?.length < 10 ||
                            bankResultStatus === 400
                          ) {
                            toast.error("Kindly verify your account before proceeding.", {
                              position: "top-right",
                              autoClose: 5000,
                              hideProgressBar: false,
                              pauseOnHover: true,
                              progress: undefined,
                              theme: "light",
                            });
                            return;
                          } else {
                            handleClosePaymentR();
                            handleShowAuthenticate();
                          }
                        }}
                        // disabled={loading}
                      >
                        Make Payment
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="mt-1 mb-5 w-btn m-auto pt-3">
                    <button
                      type="button"
                      className="btn loginBtn btn-sm btn-block d-flex justify-content-center align-items-center"
                      onClick={() => {
                        handleClosePaymentR();
                        handleShowAuthenticate();
                      }}
                      // disabled={loading}
                    >
                      Initiate Payment
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PaymentRequestModal;